import React, {Component} from 'react';
import OtherVideo from './otherVideo';
import { Button, message } from 'antd';
import { ajax } from '../../../../utils/common';

class QueVideo extends Component {
  state = {
    autoPlay: false,
    showLoading: false,
    selectedIndex: 0
  }

  // 生成报告
  generateReport = () => {
    const { i18n } = this.props,
      { showLoading } = this.state;
    if(showLoading) return false;
    this.setState({
      showLoading: true
    });
    ajax({
      url: "/account/analyzeExpression"
    }).then(res => {
      message.success(i18n.report.generate);
      this.setState({
        showLoading: false
      });
    }).catch(err => {
      message.error(err.message || i18n.report.reportFail);
      this.setState({
        showLoading: false
      });
    });
  }

  handleClick = (qId, index, autoPlay) => {
    //设置选中题号
    this.setState({
      selectedIndex: index,
      autoPlay: autoPlay || false
    });
    this.props.handleClick(qId);
  }

  render() {
    const { autoPlay, selectedIndex, showLoading } = this.state;
    const { i18n, paperInfo, themeColor, videoUrl, userInfo } = this.props;
    //试题信息
    const interviewQuesVOs = paperInfo.interviewQuesVOs;
    return (
      <div className="queVideo video-mobile-box">
        <h1 className="queVideoTitle" style={{color: themeColor}}>
          <p>{i18n.result.videoTitle}<span className="total"> ( {i18n.result.total.replace('{num}', interviewQuesVOs && interviewQuesVOs.length || 0)} )</span></p>
          {(userInfo && userInfo.aiVaild === 1 && userInfo.reportStatus !== 2) && <Button className="queVideoTitleBtn" loading={userInfo.reportStatus === 1 || showLoading} onClick={() => this.generateReport()} type="primary" style={{backgroundColor: themeColor}}>{i18n.report.generateReport}</Button>}
        </h1>
        <div className="queVideoCon">
          <OtherVideo videoUrl={videoUrl}
                      selectedIndex={selectedIndex} paperInfo={paperInfo}
                      handleClick={this.handleClick} themeColor={themeColor} autoPlay={autoPlay} />
          <ul className="interviewQues">
            {interviewQuesVOs && interviewQuesVOs.map((item, index) => (
              <li key={index} onClick={() => this.handleClick(item.questionId, index)} style={selectedIndex === index ? {color: '#444444'} : {}}>
                <span className="iconfont icon-ask" style={selectedIndex === index ? {color: themeColor} : {}} />
                {i18n.lang === 'en_us' ? item.enName : item.cnName}
              </li>
            ))}
          </ul>
        </div>
      </div>
    );
  }
}

export default QueVideo;
